import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { TableBtn, TableColumn } from 'src/app/shared/interfaces';
import { AuthenticationService, UserService } from 'src/app/_services';
import { ExportCSVService } from 'src/app/_services/export-csv.service';
import { SnackbarService } from 'src/app/_service/message-service';
import { ActivatedRoute, Router } from '@angular/router';
import { UserInfoService } from 'src/app/_services/userInfo.service';
import { Permission } from 'src/app/util/enums/permission.enum';
import { MenuRouteID } from '../header/menu-item/nav-item';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { BreadcrumbService } from '../breadcrumb/breadcrumb.service';
import { RouteConstants } from 'src/app/util/route.constants';
import { BillingList } from '../report/recon-report/recon-report.component';
import { BillingService } from 'src/app/_services/billing.service.v2';
declare var $: any;

export interface transactionData {
  chargeboxId: string;
  name: string;
  vendorId: string;
}

export interface transactionDataById {
  username: string;
  amount: number;
  operation: string;
  created_date: string;
  chargebox_id: string;
  connector_id: string;
  vendorId: string;
  transaction_id: string;
  total_meter_value: string;
  status: string;
  sequence: number;
  vendorName: string;
  city: string;
  country: string;
  disableInvoice: boolean;
  paymentStatus: string;
}
@Component({
  selector: 'telio-charging-transactions',
  templateUrl: './charging-transactions.component.html',
  styleUrls: ['./charging-transactions.component.scss']
})
export class ChargingTransactionsComponent implements OnInit , OnDestroy {
  @ViewChild('transactionmodel', { static: false }) transactionmodel: TemplateRef<any>;
  subscription: Subscription = new Subscription;
  uniqueList: transactionData[];
  uniqueListById: transactionDataById[];
  initialTransactionData: any;
  columns: TableColumn[];
  tcolumns: TableColumn[];
  buttons: TableBtn[];
  tbuttons: TableBtn[];
  actionHeader: string = '';
  filterPlaceholder: string = '';
  userID;
  pageList = {
    currentPage: 0,
    pageSize: 10
  };
  currentPage = 0;
  totalDataCount = 0;
  sortColumn = '';
  sortDirection = 'asc';
  transactionIdCount = 0;
  vendor: any = {}
  initialData: any;
  initialAllData: any;

  constructor(private userservice: UserService, public dialog: MatDialog,private billingService:BillingService,
    readonly translate: TranslateService, readonly exportCSVService: ExportCSVService, private toastr: SnackbarService,
    private userInfoService: UserInfoService, readonly route: ActivatedRoute, private authenticationService: AuthenticationService,
    private router: Router,readonly breadcrumbService: BreadcrumbService) {
    this.getUniqueTransaction(this.pageList)
    this.columns = [
      { columnDef: 'name', header: 'cpoList.cpoName', cell: (element: transactionData) => `${element.name}`, sortingDisabled: false, width: '80px', isLink: this.userInfoService.isTabExists(+this.route.snapshot.paramMap.get('routeID')) },
      { columnDef: 'chargeboxId', header: 'wallets.chargeboxId', cell: (element: transactionData) => `${element.chargeboxId}`, sortingDisabled: false, width: '80px', isLink: this.userInfoService.isTabExists(+this.route.snapshot.paramMap.get('routeID')) },
    ];
    this.tcolumns = [
      { columnDef: 'vendorId', header: 'cpoList.cpoName', cell: (element: transactionDataById) => `${element.vendorName}`, sortingDisabled: true, width: '80px' },
      { columnDef: 'chargebox_id', header: 'wallets.chargeboxId', cell: (element: transactionDataById) => `${element.chargebox_id}`, sortingDisabled: true, width: '80px' },
      { columnDef: 'connector_id', header: 'wallets.connectorId', cell: (element: transactionDataById) => `${element.connector_id}`, sortingDisabled: false, width: '80px', align: 'center' },
      { columnDef: 'transaction_id', header: 'wallets.tnxId', cell: (element: transactionDataById) => `${element.transaction_id}`, sortingDisabled: false, width: '80px', align: 'center' },
      { columnDef: 'username', header: 'wallets.userName', cell: (element: transactionDataById) => `${element.username}`, sortingDisabled: false, width: '80px', caseSensitive: 'capitalize' },
      { columnDef: 'total_meter_value', header: 'wallets.totalMeterValue', cell: (element: transactionDataById) => `${element.total_meter_value}`, sortingDisabled: false, width: '80px', align: 'center' },
      { columnDef: 'amount', header: 'wallets.amountWithCurrency', cell: (element: transactionDataById) => `${element.amount}`, sortingDisabled: false, width: '80px', isCurrency: true, align: 'right', headerAlign: true },
      { columnDef: 'paymentStatus', header: 'wallets.paymentStatus', cell: (element: transactionDataById) => `${element.paymentStatus}`, sortingDisabled: false, width: '80px', align: 'center' },
      { columnDef: 'created_date', header: 'wallets.paymentDate', cell: (element: transactionDataById) => `${element.created_date}`, sortingDisabled: false, width: '80px' },
      { columnDef: 'status', header: 'wallets.status', cell: (element: transactionDataById) => `${element.status}`, sortingDisabled: false, width: '80px', caseSensitive: 'uppercase' }
    ]
    this.buttons = [
      { styleClass: 'submit', icon: 'remove_red_eye', payload: (element: transactionData) => `${element.chargeboxId}`, action: 'view', tooltip: 'wallets.viewTransactions', enable: this.checkPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.READ) },
    ];

    this.tbuttons = [
      { styleClass: 'submit', icon: 'download', payload: (element: transactionDataById) => `${element.transaction_id}`, action: 'download', tooltip: 'wallets.download', isDisabled: (element: transactionDataById) => `${element.disableInvoice}`, enable: this.checkPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.READ) },
    ]
    this.filterPlaceholder = 'generalTable.filterPlaceholder';
    this.actionHeader = 'wallets.actions';
  }


  ngOnInit(): void {
  }

  getUniqueTransaction(value: any, searchFilter: string = '') {
    this.userservice.getUniqueTransaction(value.currentPage + 1, value.pageSize, this.sortColumn, this.sortDirection, searchFilter).subscribe((res: any) => {
      this.uniqueList = res.data;
      this.totalDataCount = res.totalItems;
      this.setUniqueTransactionMap(this.uniqueList)
    },
      (err: HttpErrorResponse) => {
        this.toastr.error(this.translate.instant('billingReport.responseFailed'));
      }
    );
  }


  getTransactionBasedonId(id, value: any, searchFilter: string = '') {
    this.userservice.getTransactionBasedOnId(id, value.currentPage + 1, value.pageSize, this.sortColumn, this.sortDirection, searchFilter).subscribe((res: any) => {
      this.uniqueListById = res.data;
      this.transactionIdCount = res.totalItems;
      this.setAllTransactionMap(this.uniqueListById)
    },
      (err: HttpErrorResponse) => {
        this.toastr.error(this.translate.instant('billingReport.responseFailed'));
      }
    );
  }

  applyFilter(filteredData: string) {
    this.getUniqueTransaction(this.pageList, filteredData)
  }

  applyFilters(filteredData: string) {
    this.getTransactionBasedonId(this.userID, this.pageList, filteredData)
  }

  actionCSV() {
    const options = {
      filename: this.translate.instant('wallets.transactions'),
      showTitle: false,
      title: this.translate.instant('wallets.transactions'),
      useKeysAsHeaders: true,
    }
    this.subscription.add(this.userservice.getUniqueTransaction(1, this.totalDataCount, this.sortColumn, 'asc', '').subscribe(
      (resp: any) => {
        this.initialData = resp.data;
        this.setUniqueTransactionMap(this.initialData)
        this.exportCSVService.exportCSV(options, this.initialData);
      }
    ))
  }
  actionCSVId() {
    const options = {
      filename: this.translate.instant('wallets.transactions'),
      showTitle: false,
      title: this.translate.instant('wallets.transactions'),
      useKeysAsHeaders: true,
    }
    this.subscription.add(this.userservice.getTransactionBasedOnId(this.userID, 1, this.transactionIdCount, this.sortColumn, 'asc', '').subscribe(
      (resp: any) => {
        this.initialAllData = resp.data
        this.setAllTransactionMap(this.initialAllData)
        this.initialAllData.sort((a, b) => a.sequence - b.sequence)
        this.exportCSVService.exportCSV(options, this.initialAllData);
      }
    ))
  }

  setUniqueTransactionMap(data) {
    data.map((item: any, i: number) => {
      let empty = 'NA';
      item.name = !item.name ? empty : item.name
      item.vendorId = !item.vendorId ? empty : item.vendorId
      item.chargeboxId = !item.chargeboxId ? empty : item.chargeboxId
    });
  }

  setAllTransactionMap(data) {
    data.map((item: any, i: number) => {
      let empty = 'NA';
      item.username = !item.username ? empty : item.username.toLowerCase()
      item.city = !item.city ? empty : item.city.toUpperCase()
      item.country = !item.country ? empty : item.country.toUpperCase()
      item.vendorId = !item.vendor_id ? empty : item.vendor_id
      item.vendorName = !item.vendorName ? empty : item.vendorName
      item.chargebox_id = !item.chargebox_id ? empty : item.chargebox_id
      item.connector_id = !item.connector_id ? empty : item.connector_id
      item.transaction_id = !item.transaction_id ? empty : item.transaction_id
      item.amount = (+item.amount).toFixed(2)
      item.paymentStatus = !item.paymentStatus ? empty : item.paymentStatus.toUpperCase();
      item.operation = !item.operation ? empty : item.operation
      item.created_date = !item.created_date ? empty : this.authenticationService.convert24HrTo12Hr(this.authenticationService.convertToLocalTime(item.created_date, this.userInfoService.userDetails.prefCountry));
      item.status = !item.status ? empty : item.status.toUpperCase();
      item.sequence = item.sequence
      item.total_meter_value = ((item.total_meter_value) / 1000).toFixed(2)
      item.disableInvoice = !item.invoiceFlag ? true : false
    });
  }


  buttonClick(result: string[]) {
    this.userID = result[1]
    this.getTransactionBasedonId(this.userID, this.pageList)
    $('#transactionmodel').modal('show')
  }

  loadData(value: any) {
    let val = {
      currentPage: value.currentPage,
      pageSize: value.pageSize
    }
    this.pageList.pageSize = value.pageSize;
    this.getUniqueTransaction(val, '')
  }

  sortClick(event: any) {
    this.sortColumn = event.active;
    this.sortDirection = event.direction;
    this.getUniqueTransaction(this.pageList, '');
  }

  loadDataDetail(value: any) {
    let val = {
      currentPage: value.currentPage,
      pageSize: value.pageSize
    }
    this.pageList.pageSize = value.pageSize;
    this.getTransactionBasedonId(this.userID, val, '')
  }

  sortClickDetail(event: any) {
    this.sortColumn = event.active;
    this.sortDirection = event.direction;
    this.getTransactionBasedonId(this.userID, this.pageList, '');
  }

  actionClick() {
    this.getUniqueTransaction(this.pageList)
  }
  ngOnDestroy() {
    this.subscription && this.subscription.unsubscribe();
  }

  pdfDownload(id) {
    this.billingService.getInvoice(id).subscribe((res: any) => {
      const url = window.URL.createObjectURL(res);
      window.open(url);
    }, error => {
      error.status == 404 ? this.toastr.error(this.translate.instant('wallets.downloadError')) :
        this.toastr.error(this.translate.instant('responseFailed'))
    });
  }

  buttonsClick(event) {
    this.pdfDownload(event[1]);
  }

  linkClick(event) {
    this.userID = event.row.chargeboxId;
    if (event.column.columnDef == "chargeboxId") {
      this.router.navigate(['/dashboard/stations/details', { routeID: MenuRouteID.STATIONS }], { queryParams: { "stationid": JSON.stringify(this.userID), "routedName": 'chargingTransactions', } })
      this.breadcrumbService.emitBreadCrumbs(RouteConstants.CHARGING_TRANSACTION_STATION);
    }
    else if (event.column.columnDef = "name") {
      this.vendor = event.row.vendorId;
      this.router.navigate(['/dashboard/operators/details', { routeID: MenuRouteID.OPERATORS }], { queryParams: { "vendorid": JSON.stringify(this.vendor), index: '0', routedName: 'chargingTransactions' } })
      this.breadcrumbService.emitBreadCrumbs(RouteConstants.CHARGING_TRANSACTION_OPERATOR);
    }
  }

  checkPermission(id: number, permission: string): boolean {
    return this.userInfoService.filterPermission(id, permission)
  }

  convertDateTime(date) {
    var tzo = -date.getTimezoneOffset(),
      dif = tzo >= 0 ? '+' : '-',
      pad = function (num) {
        return (num < 10 ? '0' : '') + num;
      };

    return date.getFullYear() +
      '-' + pad(date.getMonth() + 1) +
      '-' + pad(date.getDate()) +
      'T' + pad(date.getHours()) +
      ':' + pad(date.getMinutes()) +
      ':' + pad(date.getSeconds()) +
      dif + pad(Math.floor(Math.abs(tzo) / 60)) +
      ':' + pad(Math.abs(tzo) % 60);
  }
}
